<div class="commission-detail-dialog">
  <div class="commission-detail-dialog-header flex-between-center">
    <p class="font-bold font-18 m-0">
      <i class="fas fa-envelope-open-dollar font-primary commission-header-icon mr-2"></i>
      <span>Commissions - RO# {{orderCode}}</span>
    </p>

    <div class="flex-end-center">
      <button *ngIf="canViewEditCommission" class="btn btn-sync mr-3" pTooltip="Resyncing will override Manual commissions" tooltipPosition="top"
        [disabled]="isSyncing" (click)="handleConfirmSync()">
        <i class="far fa-sync mr-2" [ngClass]="{'rotate': isSyncing}"></i>
        Sync
      </button>

      <span class="close-modal">
        <i class="fal fa-times" (click)="handleClose()"></i>
      </span>
    </div>
  </div>

  <div class="commission-detail-dialog-body">
    <!-- Commission stats -->
    <div class="commission-card-wrapper flex-start-center">
      <div *ngFor="let stat of stats; let statIndex = index" class="commission-card flex-column">
        <div class="commission-card-line {{stat?.role?.length === 1? stat?.role[0] : 'serviceWriter'}}"></div>
        <div class="flex-between-center width-max-content">
          <span class="font-600 pr-5" [pTooltip]="stat?.employee?.fullName">{{ stat?.employee?.displayName }}</span>
          <span class="font-bold">{{ stat?.commissionEarn || 0 | currency: usd }}</span>
        </div>

        <div *ngIf="stat?.role?.length === 1 else hybridRole" class="flex-start-center width-max-content">
          <div class="role-badge {{stat?.role[0]}}">
            <span>{{ stat?.role[0] === 'tech'? 'Tech' : 'Service advisor' }}</span>
          </div>
        </div>

        <ng-template #hybridRole>
          <div class="flex-start-center width-max-content">
            <span class="role-badge multi-role {{stat?.role[0]}}">
              {{ (stat?.role[0] === 'tech'? stat?.techCommission : stat?.advisorCommission) || 0 | currency: usd }}
              {{ stat?.role[0] === 'tech'? 'Tech' : 'Service advisor' }}
            </span>
            <span class="mr-1 ml-1">+</span>
            <span class="role-badge multi-role {{stat?.role[1]}}">
              {{ (stat?.role[1] === 'tech'? stat?.techCommission : stat?.advisorCommission) || 0 | currency: usd }}
              {{ stat?.role[1] === 'tech'? 'Tech' : 'Service advisor' }}
            </span>
          </div>
        </ng-template>
      </div>
    </div>

    <div class="commission-detail-container flex-start-start">
      <!-- Commission Metric -->
      <div class="commission-metrics flex-column">
        <div *ngIf="invoiceMetrics?.length" class="flex-column">
          <div class="commission-metrics-heading flex-start-center mt-3 mb-3">
            <span class="font-bold">Invoice&nbsp;Metrics&nbsp;&nbsp;</span>
            <div class="horizontal-line"></div>
          </div>

          <div class="ui-g-12 p-0 commission-metrics-body flex-column">
            <div class="metric">
              <div class="ui-g-3 p-0 font-600 font-13">RO Gross Profit</div>

              <div class="ui-g-9 p-0">
                <div class="ui-g-12 p-0">
                  <div *ngFor="let metric of invoiceMetrics" class="metric-card flex-column mb-2">
                    <div class="flex-between-center metric-card-top mt-1">
                      <span class="font-600" [pTooltip]="metric?.employee?.fullName">
                        {{ metric?.employee?.displayName }}
                      </span>
                      <span class="font-bold">{{metric?.commissionEarn || 0 | currency: usd }}</span>
                    </div>

                    <div class="flex-between-center metric-card-bottom mt-1">
                      <span class="flex-start-center">
                        <i class="fal fa-clipboard mr-1"></i>
                        <span>{{metric?.commission?.name}}</span>
                      </span>

                      <span *ngIf="canViewEditCommission">
                        <i class="fal fa-edit commission-edit-icon pointer"
                          (click)="handleEditEmployeeCommission(metric?.employee)"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="serviceMetrics?.length" class="flex-column">
          <div class="commission-metrics-heading flex-start-center mt-3 mb-3">
            <span class="font-bold">Service&nbsp;Metrics&nbsp;&nbsp;</span>
            <div class="horizontal-line"></div>
          </div>

          <div class="ui-g-12 p-0 commission-metrics-body flex-column">
            <div *ngFor="let metrics of serviceMetrics" class="metric mb-4">
              <div class="ui-g-3 p-0 font-600 font-13">Service: {{metrics && metrics[0]?.service?.title}}</div>

              <div class="ui-g-9 p-0 flex-start-center flex-wrap">
                <div *ngFor="let metric of metrics" class="metric-card flex-column mb-3">
                  <!-- Role tag -->
                  <div *ngIf="metric?.employee?.role === 'tech'" class="role-tag normal">
                    <div class="bg-bar"></div>

                    <span class="flex-start-center">
                      <span class="pl-2 pr-2 tag-text">Tech</span>
                    </span>
                  </div>

                  <div class="flex-between-center metric-card-top mt-1">
                    <span class="font-600" [pTooltip]="metric?.employee?.fullName">
                      {{metric?.employee?.displayName}}
                    </span>
                    <span class="font-bold">{{metric?.commissionEarn || 0 | currency: usd }}</span>
                  </div>

                  <div class="flex-between-center metric-card-bottom mt-1">
                    <span class="flex-start-center">
                      <i class="fal fa-clipboard mr-1"></i>
                      <span>{{metric?.commission?.name}}</span>
                    </span>

                    <span *ngIf="canViewEditCommission">
                      <i class="fal fa-edit commission-edit-icon pointer"
                        (click)="handleEditEmployeeCommission(metric?.employee, metric?.service?.orderServiceId)"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Activity Log -->
      <div *ngIf="canViewEditCommission" class="commission-activity mb-3">
        <p class="font-bold mb-4 mt-3 ml-3">Activity logs</p>

        <div *ngIf="activityLogs?.length" class="position-relative">
          <div class="activity-divider"></div>
          <div class="activity-circle"></div>
          <ng-container *ngFor="let activity of activityLogs">
            <div class="commission-plan-activity flex-start-start width-100p mb-3 position-relative">
              <div class="activity-icon-wrapper flex-center-center">
                <div class="activity-icon flex-center-center text-transform-uppercase core-activity">
                  <span class="font-16 font-800 activity-icon-name-initilas">{{activity?.data?.initials}}</span>
                </div>
              </div>

              <div class="activity-overview flex-column">
                <p class="m-0 font-gray-35 font-10">
                  {{getTime(activity?.createdAt)}}
                </p>

                <div class="flex-start">
                  <p class="m-0" [ngClass]="{'text-truncate': isAllPlanLogs}" [innerHTML]="activity?.text"></p>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>

  </div>
</div>
